import React, { useRef, useEffect, useState } from 'react';
import NavBars from '../../Sidebar/Sidebar';
import './Admin.css';
import Table from './Table';
import { db } from '../../../firebase';
import { UserAuth } from '../../../authContext';
import {
    updateDoc, getDoc, arrayUnion, collection, query, where,
    getDocs, deleteDoc, doc,addDoc
} from 'firebase/firestore';

const AdminRequest = () => {
    const { user } = UserAuth();
    const joinTableRef = useRef(null);
    const purchaseTableRef = useRef(null);
    const [currentOption, setCurrentOption] = useState('Join');
    const [buttonLabel, setButtonLabel] = useState('$');
    const [buttonData, setButtonData] = useState([]);

    const [joinRows, setJoinRows] = useState(0);
    const [joinData, setJoinData] = useState([]);
    const joinColumns = 7;
    const joinColumnTypes = ['label', 'label', 'label', 'label', 'label', 'button', 'button'];
    const joinColumnNames = ['ID', 'Proj_ID', 'User','Name', 'Project', 'Accept', 'Deny'];
    const joinButtonNames = ['Deny', 'Accept'];

    const [purchaseRows, setPurchaseRows] = useState(0);
    const [purchaseData, setPurchaseData] = useState([]);
    const purchaseColumns = 10;
    const purchaseColumnTypes = ['label', 'label', 'label', 'label', 'label', 'button', 'button', 'button', 'button', 'button'];
    const purchaseColumnNames = ['ID', 'Date', 'User', 'Product', 'Quantity', 'Product Link', 'Image Link', 'Description', 'Approve', 'Reject'];
    const purchaseButtonNames = ['Approve', 'Reject', 'View Description', 'View Image', 'View Product'];

    useEffect(() => {
        handleOptionClick('Join');
    }, []);

    const handleOptionClick = async (option) => {
        setCurrentOption(option);
        setButtonLabel(option === 'Join' ? '$' : '^');
        if (option === 'Join') {
            await fetchJoinData();
        } else if (option === 'Purchase') {
            await fetchPurchaseData();
        }
    };

    const toggleOption = () => {
        const newOption = currentOption === 'Join' ? 'Purchase' : 'Join';
        handleOptionClick(newOption);
    };

    const fetchJoinData = async () => {
        try {
            const q = query(collection(db, 'requests'), where('type', '==', 'Join'));
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            const formattedData = data.map(item => [
                item.id,
                item.projID || 'N/A',
                item.userEmail || 'N/A',
                item.name || 'N/A',
                item.projectName || 'N/A',
                'Deny',
                'Accept'
            ]);
            setButtonData(data.map(item => [
                item.imageLink,
                item.productLink || 'N/A',
                item.description || 'N/A'
            ]));
            setJoinData(formattedData);
            setJoinRows(formattedData.length);
        } catch (error) {
            console.error('Error fetching join data:', error);
        }
    };

    const fetchPurchaseData = async () => {
        try {
            const q = query(collection(db, 'requests'), where('type', '==', 'Purchase'));
            const querySnapshot = await getDocs(q);
            const formattedData = querySnapshot.docs.map(doc => {
                const data = doc.data();
                return [
                    doc.id,
                    data.timestamp ? new Date(data.timestamp.toDate()).toLocaleDateString() : 'N/A',
                    data.userEmail || 'N/A',
                    data.productName || 'N/A',
                    data.quantity || 'N/A',
                    'View Product',
                    'View Image',
                    'View Description',
                    'Approve',
                    'Reject'
                ];
            });
            setPurchaseData(formattedData);
            setPurchaseRows(formattedData.length);
            setButtonData(querySnapshot.docs.map(doc => [
                doc.data().imageLink || 'N/A',
                doc.data().productLink || 'N/A',
                doc.data().description || 'N/A'
            ]));
        } catch (error) {
            console.error('Error fetching purchase data:', error);
        }
    };

    const handleClearJoinItem = async (rowIndex) => {
        const itemId = joinData[rowIndex][0];
        try {
            if (window.confirm("Are you sure you want to delete this item?")) {
                await deleteDoc(doc(db, 'requests', itemId));
                const updatedData = joinData.filter((_, index) => index !== rowIndex);
                setJoinData(updatedData);
                setJoinRows(updatedData.length);
            }
        } catch (error) {
            console.error('Error deleting join item:', error);
            alert('An error occurred while deleting the item. Please try again.');
        }
    };

    const handleAccept = async (rowIndex) => {
        const selectedRow = joinData[rowIndex];
        const userEmail = selectedRow[2]; // Assuming email is in the first column
        const selectedProjectID = selectedRow[1]; // Assuming project ID is in the second column
    
        try {
            const projectRef = doc(db, 'Projects', selectedProjectID);
            const projectDoc = await getDoc(projectRef);
            const projectName = projectDoc.exists() ? projectDoc.data().name : 'Unknown Project';
    
            // Get the user document reference based on email
            const userQuerySnapshot = await getDocs(
                query(collection(db, 'users'), where('email', '==', userEmail))
            );
    
            if (userQuerySnapshot.empty) {
                throw new Error(`User with email ${userEmail} not found.`);
            }
    
            const userDocRef = userQuerySnapshot.docs[0].ref;
            const userID = userQuerySnapshot.docs[0].id;
    
            // Update the user's document to add the project
            await updateDoc(userDocRef, {
                projects: arrayUnion(projectRef)
            });
    
            // Update the project document to add the user ID as a member
            await updateDoc(projectRef, {
                members: arrayUnion(userID)
            });
    
            alert(`${userEmail} has successfully been added to ${projectName}`);
            handleClearJoinItem(rowIndex);
        } catch (error) {
            console.error('Error joining project:', error);
            alert('An error occurred while joining the project. Please try again.');
        }
    };
    

    const handleApprovePurchase = async (rowIndex) => {
        // Ask the user if it's a Tool or an Item
        const category = prompt('Enter "TOOL" or "ITEM":').toUpperCase();
    
        if (category !== "TOOL" && category !== "ITEM") {
            alert("Invalid input. Please enter either TOOL or ITEM.");
            return;
        }
    
        // Access the row data dynamically using the rowIndex
        const rowData = purchaseData[rowIndex];
        if (!rowData) {
            alert("Invalid row data.");
            return;
        }
    
        // Access buttonData for additional fields
        const [imageLink, productLink, description] = buttonData[rowIndex] || ["N/A", "N/A", "N/A"];
    
        // Prepare data based on the category and rowData
        const data = category === "TOOL"
            ? {
                Name: rowData[3] || "Unknown Tool", // Assuming rowData[3] is the Product Name
                TotalQuantity:  "0", // Assuming rowData[4] is the Quantity
                image: imageLink || "", // Image from buttonData
            }
            : {
                Name: rowData[3] || "Unknown Item",
                TotalQuantity: rowData[4] || "0",
                AvailQuantity: "0", // Default values for ITEM
                ResQuantity: "0",
                TakenAmount: "0",
                image: imageLink || "",
                description: description || "", // Description from buttonData
                Documentation: productLink || ""
            };
    
        try {
            // Define the collection name
            const collectionName = category === "TOOL" ? "Tools" : "Items";
    
            // Add the data to the Firestore collection using addDoc
            const docRef = await addDoc(collection(db, collectionName), data);
    
            // Success message
            alert(`${category} added successfully to the ${collectionName} collection with ID: ${docRef.id}`);
        } catch (error) {
            // Error handling
            console.error("Error adding document:", error);
            alert("Failed to add the document. Check the console for details.");
        }
    };
    
    
    

    const handleRejectPurchase = async (rowIndex) => {
        const itemId = purchaseData[rowIndex][0];
        try {
            if (window.confirm("Are you sure you want to reject this purchase?")) {
                await deleteDoc(doc(db, 'requests', itemId));
                const updatedData = purchaseData.filter((_, index) => index !== rowIndex);
                setPurchaseData(updatedData);
                setPurchaseRows(updatedData.length);
            }
        } catch (error) {
            console.error('Error rejecting purchase:', error);
            alert('An error occurred while rejecting the purchase. Please try again.');
        }
    };

    const handleViewDescription = (rowIndex) => {
        const description = buttonData[rowIndex][2];
        const newWindow = window.open();
        newWindow.document.write(`
            <html>
                <head><title>Description</title></head>
                <body><p>${description}</p></body>
            </html>
        `);
        newWindow.document.close();
    };

    const handleViewImage = (rowIndex) => {
        const imageLink = buttonData[rowIndex][0];
        window.open(imageLink, '_blank');
    };

    const handleViewProduct = (rowIndex) => {
        const productLink = buttonData[rowIndex][1];
        window.open(productLink, '_blank');
    };

    return (
        <div>
            <div className="content">
                {currentOption === 'Join' && (
                    <Table
                        ref={joinTableRef}
                        rows={joinRows}
                        columns={joinColumns}
                        columnTypes={joinColumnTypes}
                        columnNames={joinColumnNames}
                        data={joinData}
                        buttonNames={joinButtonNames}
                        onButtonClick={[
                            handleClearJoinItem, handleAccept
                        ]}
                    />
                )}
                {currentOption === 'Purchase' && (
                    <Table
                        ref={purchaseTableRef}
                        rows={purchaseRows}
                        columns={purchaseColumns}
                        columnTypes={purchaseColumnTypes}
                        columnNames={purchaseColumnNames}
                        data={purchaseData}
                        buttonNames={purchaseButtonNames}
                        onButtonClick={[
                            handleApprovePurchase,
                            handleRejectPurchase,
                            handleViewDescription,
                            handleViewImage,
                            handleViewProduct
                        ]}
                    />
                )}
            </div>
            <NavBars />
            <div>
                <button onClick={toggleOption} className="floating-button">{buttonLabel}</button>
            </div>
        </div>
    );
};

export default AdminRequest;
